import React, { Component } from "react";
import "./AddressZone.css";

class AddressZone extends Component {
  componentDidMount() {
    this.renderMap();
    // this.sendParentData("zone123");
  }

  constructor(props) {
    super(props);
    console.log(props)
    this.state = {
      // lat:80.2648512,
      // lng:13.0552786,
      lat: props.lat,
      lng: props.lng,
      zoneName: ""
    }
    this.sendParentData = this.sendParentData.bind(this);
    // this.drawRectangle = this.drawRectangle.bind(this);
  }

  renderMap = () => {
    loadScript(
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBBTbZ_U1tJKRL_GPdrIm5ecJsUFH9T0Wk&callback=initMap"
    );
    window.initMap = this.initMap;
  };

  initMap = () => {
    var myLatlng;
    var mapOptions;
    var addressZone;
    myLatlng = new window.google.maps.LatLng(12.72469, 79.8788);

    mapOptions = {
      zoom: 14,
      center: myLatlng,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP
    };

    var map = new window.google.maps.Map(
      document.getElementById("map"),
      mapOptions
    );

    window.google.maps.event.addListenerOnce(map, "idle", function () {
      this.drawRectangle(map, this.state.lat, this.state.lng);
    }.bind(this));



    console.log("out" + addressZone)

    // if(addressZone!=undefined){
    this.setState({ zoneName: addressZone }, () => this.sendParentData(addressZone));
    // console.log("Zone Name : "+ this.state.zoneName);
    // this.sendParentData(addressZone);
    // }

  };

  drawRectangle = (map, lat, lng) => {
    console.log(lat)
    var numberOfRows = 15;
    var numberOfColumns = 9;

    var tileHeight = 0.05;
    var tileWidth = 0.05;
    let zoneNumber = 1;
    var zoneCoordinates = [];
    for (var x = 0; x < numberOfColumns; x++) {
      for (var y = 0; y < numberOfRows; y++) {
        var areaBounds = {
          north: 12.67469 + tileHeight * (y + 1),
          south: 12.67469 + tileHeight * y,
          east: 79.8788 + tileWidth * (x + 1),
          west: 79.8788 + tileWidth * x
          // north: 12.72469 + tileHeight * (y + 1),
          // south: 12.72469 + tileHeight * y,
          // east: 79.8788 + tileWidth * (x + 1),
          // west: 79.8788 + tileWidth * x
        };
        var rectangle = new window.google.maps.Rectangle({
          strokeColor: "#FF0000",
          strokeWeight: 1,
          map: map,
          bounds: areaBounds
        });

        var z1p1 = [
          rectangle
            .getBounds()
            .getSouthWest()
            .lng(),
          rectangle
            .getBounds()
            .getSouthWest()
            .lat()
        ];
        var z1p2 = [
          rectangle
            .getBounds()
            .getSouthWest()
            .lng(),
          rectangle
            .getBounds()
            .getNorthEast()
            .lat()
        ];
        var z1p3 = [
          rectangle
            .getBounds()
            .getNorthEast()
            .lng(),
          rectangle
            .getBounds()
            .getNorthEast()
            .lat()
        ];
        var z1p4 = [
          rectangle
            .getBounds()
            .getNorthEast()
            .lng(),
          rectangle
            .getBounds()
            .getSouthWest()
            .lat()
        ];
        var z1c1 = [
          rectangle
            .getBounds()
            .getCenter()
            .lng(),
          rectangle
            .getBounds()
            .getCenter()
            .lat()
        ];

        var z = [z1p1, z1p2, z1p3, z1p4, z1c1, "zone" + zoneNumber];
        zoneCoordinates.push(z);
        zoneNumber++;
      }
    }

    // console.log(zoneCoordinates)

    var zoneDistances = [];
    // let lat,lng;
    // lat=80.10;
    // lng=13.05;
    zoneCoordinates.map((zoneFrom, index) => {
      var p1, p2, p3, p4, p5;

      p1 = calcCrow(
        zoneFrom[0][0],
        zoneFrom[0][1],
        lat,
        lng
      );
      p2 = calcCrow(
        zoneFrom[1][0],
        zoneFrom[1][1],
        lat,
        lng
      );
      p3 = calcCrow(
        zoneFrom[2][0],
        zoneFrom[2][1],
        lat,
        lng
      );
      p4 = calcCrow(
        zoneFrom[3][0],
        zoneFrom[3][1],
        lat,
        lng
      );
      p5 = calcCrow(
        zoneFrom[4][0],
        zoneFrom[4][1],
        lat,
        lng
      );

      if (p1 < 5 && p2 < 5 && p3 < 5 && p4 < 5 && p5 < 5) {

        var zone = [zoneFrom[5], p1, p2, p3, p4, p5];
        zoneDistances.push(zone);


      }
      // var zone = [zoneFrom[5],  p1, p2, p3, p4, p5];
      // zoneDistances.push(zone);

    });
    // console.log(zoneDistances)
    var centerArr = []
    zoneDistances.map(d => {
      centerArr.push(d[5])
    })
    var addressZone;
    var minDistance = Math.min.apply(null, centerArr);
    addressZone = zoneDistances.filter(x => x[5] == minDistance)[0][0]
    // console.log("in" +addressZone);


    this.props.callbackFromZone(addressZone)

    //this.sendParentData(addressZone);
    //this.setState({zoneName : addressZone});
    //console.log(this.state.zoneName);
  };

  sendParentData(data) {
    console.log("sendParentData")
    console.log(data)
    this.props.callbackFromZone(data)

  }

  render() {
    return (
      <main>
        <p>Google Map</p>
        <div id="map"></div>
      </main>
    );
  }
}

function loadScript(url) {
  var index = window.document.getElementsByTagName("script")[0];
  var script = window.document.createElement("script");
  script.src = url;
  script.async = true;
  script.defer = true;
  index.parentNode.insertBefore(script, index);
}

function calcCrow(lat1, lon1, lat2, lon2) {
  var R = 6371; // km
  var dLat = toRad(lat2 - lat1);
  var dLon = toRad(lon2 - lon1);
  var lat1 = toRad(lat1);
  var lat2 = toRad(lat2);

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d.toFixed(2);
}

function toRad(Value) {
  return (Value * Math.PI) / 180;
}

export default AddressZone;
